if (!customElements.get('knox-home-explorer')) customElements.define('knox-home-explorer', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.tabs = [...this.querySelectorAll('[data-explorer-tab]')];
    this.panels = [...this.querySelectorAll('[data-explorer-panel]')];
    this.dataset.enhanced = 'true';
    this.addEventListener('click', event => {
      const tab = event.target.closest('[data-explorer-tab]');
      const open = event.target.closest('[data-explorer-open]');
      if (tab) this.select(tab.dataset.explorerTab, false, false);
      if (open) this.select(open.dataset.explorerOpen, true, true);
    }, { signal });
    this.addEventListener('keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      const tab = event.target.closest('[data-explorer-tab]');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const current = this.tabs.indexOf(tab);
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
      this.select(this.tabs[index].dataset.explorerTab, false, false);
      this.tabs[index].focus({ preventScroll: true });
    }, { signal });
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-explorer-target], [data-plan]');
      if (!link || link.closest('knox-home-explorer')) return;
      const requested = link.dataset.explorerTarget || link.dataset.plan;
      if (!['build', 'deploy', 'help', 'procurement', 'try'].includes(requested)) return;
      event.preventDefault();
      this.select(['procurement', 'try'].includes(requested) ? 'help' : requested, true, true, requested === 'procurement' ? 'procurement' : requested === 'try' ? 'try' : 'help');
    }, { signal });
    const params = new URLSearchParams(location.search);
    const plan = params.get('plan');
    const focuses = { xr: 'XR', robotics: 'Robotics', both: 'Both', 'xr + robotics': 'Both', unsure: 'Not sure yet' };
    this.pendingFocus = focuses[String(params.get('focus') || '').toLowerCase()];
    const hasResult = this.querySelector('knox-help-studio')?.dataset.hasResult === 'true';
    const mode = hasResult ? 'help' : ['build', 'deploy', 'help'].includes(plan) ? plan : ['procurement', 'try'].includes(plan) ? 'help' : 'deploy';
    const recognizedPlan = ['build', 'deploy', 'help', 'procurement', 'try'].includes(plan);
    this.select(mode, Boolean(hasResult || recognizedPlan), false, plan === 'procurement' ? 'procurement' : plan === 'try' ? 'try' : undefined);
    if (location.hash === '#setup-planner' && !plan && !hasResult) requestAnimationFrame(() => this.scrollIntoView({ block: 'start', behavior: 'auto' }));
  }
  select(mode, scroll, focus, helpMode) {
    if (!['build', 'deploy', 'help'].includes(mode)) return;
    this.dataset.mode = mode;
    this.tabs.forEach(tab => {
      const active = tab.dataset.explorerTab === mode;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach(panel => { panel.hidden = panel.dataset.explorerPanel !== mode; });
    if (mode === 'help' && (helpMode || this.pendingFocus)) {
      const host = this.querySelector('knox-help-studio');
      customElements.whenDefined('knox-help-studio').then(() => {
        if (!this.isConnected || this.dataset.mode !== 'help' || !host) return;
        if (helpMode) host.setMode(helpMode);
        if (this.pendingFocus) {
          const field = host.querySelector('[name="contact[Focus]"]');
          if (host.setFocus) host.setFocus(this.pendingFocus);
          else if (field) { field.value = this.pendingFocus; field.dispatchEvent(new Event('change', { bubbles: true })); }
          this.pendingFocus = null;
        }
      });
    }
    if (scroll) requestAnimationFrame(() => {
      if (!this.isConnected) return;
      this.scrollIntoView({ block: 'start', behavior: scroll === 'instant' || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    if (focus) this.tabs.find(tab => tab.dataset.explorerTab === mode)?.focus({ preventScroll: true });
  }
  disconnectedCallback() { this.controller?.abort(); }
});